<template>    
  <v-form style="width:100%">      
    <map-tool-list :uiid="uiid" />
  </v-form>  
</template>
<script>    
  import MapToolList from '@/components/map/MapToolList'

  export default {    
    name: 'MapPanelTools',            
    components: {MapToolList},
    props:{
      uiid:{
          type: String,
          required: true,
          default: 'map_global'
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>

</style>
